import React, {ReactNode} from "react";

export function ErrorAlert({children}: {children: ReactNode}) {
    return <div className="alert">{children}</div>;
}
